// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	release: '20251231-095756',
  production: false,
  appName: 'WebDilUsuariosNoRegistrados',
  captchaKey: '6LefiUcUAAAAAMPPrsbkdaFz-JQn-Ay-mbIjMWO4'
};



// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/environments/environment.ts